// extracted by mini-css-extract-plugin
export default {"twitterFave":"Fave_twitterFave__gwBLq","faveAni":"Fave_faveAni__YG2ce","faveContainer":"Fave_faveContainer__Emn1F"};